import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import Session from '../auth/Session';
import moment from "moment";

//Comp Types currently:
//1 - Office Lease
//2 - Office Sale
//3 - Ind. Lease
//4 - Ind. Sale
//5 - Retail Lease
//6 - Land Sale
//7 - Multi Family

//Fields:
//1	2	3	4	5	6	7	id
//1	2	3	4	5	6	7	compType
//1	2	3	4	5	6	7	leaseCommencementYear
//1	2	3		5	6	7	leaseQuarter
//1	2	3		5	6	7	submarket
//1		3		5			tenant
//1	2	3	4	5			buildingName
//1	2	3	4	5	6	7	address
//1	2	3	4	5	6	7	city
//1	2	3	4	5	6	7	state
//1	2	3	4	5	6	7	Zip
//1		3		5			leasedSF
//1		3		5			term
//1		3		5			effectiveRate
//1		3		5			rateType
//1		3		5			TISF
//1		3		5			transactionType
//1		3		5			leaseExpDate
//1		3		5			buildingOwner
//1	2	3		5		7	buildingSize
//1	2	3	4	5		7	yearBuilt
//1	2	3	4				buildingClass
//1		3		5			tenantRepFirm
//1		3		5			landlordRepFirm
//1	2	3	4	5	6	7	comments
//1	2	3	4	5	6	7	source
//1	2	3	4	5	6	7	dateEntered
//2		4		6	7	buyer
//2		4		6	7	seller
//2		4		6	7	salePrice
//2		4				saleType
//2		4				occupancyPercent
//2		4				NOI
//2		4			7	capRate
//2		4		6	7	buyerRepFirm
//2		4		6	7	sellerRepFirm
//2	3	4		6	7	pressRelease
//3					commencementDate
//3					percentOffice
//3	4				lotSize
//3	4				ceilingHeight
//3	4				productType
//6		acres
//7	propertyName
//7	units

//Search stuff
//1	2	3	4	5	6	7	leaseCommencementFrom
//1	2	3	4	5	6	7	leaseCommencementTo
//1		3		5			LeasedSFFrom
//1		3		5			LeasedSFTo
//1	2	3	4	5			BuildingSizeFrom
//1	2	3	4	5			BuildingSizeTo
//1	2	3	4	5			YearBuiltFrom
//1	2	3	4	5			YearBuiltTo
//2		4		6		salePriceFrom
//2		4		6		salePriceTo
//2		4				perSQFTFrom
//2		4				perSQFTTo
//6		acreageFrom     
//6		acreageTo



export class CompsAdd extends Component {
    static displayName = CompsAdd.name;

    componentDidUpdate(prevProps) {
        if (this.props.location.search !== prevProps.location.search) {
            const search = this.props.location.search;
            const params = new URLSearchParams(search);
            const compType = params.get('compType');

            const compsList =
                [
                    { id: 1, name: "Office Lease" },
                    { id: 2, name: "Office Sale" },
                    { id: 3, name: "Industrial Lease" },
                    { id: 4, name: "Industrial Sale" },
                    { id: 5, name: "Retail Lease" },
                    { id: 6, name: "Retail Sale" },
                    { id: 7, name: "Land Sale" },
                    { id: 8, name: "Multi-Family" }
                ];


            var compInfo = compsList.find(w => w.id == compType);
            if (!compInfo) {
                compInfo = { id: 0, name: "Invalid Comp Type" };
            }

            this.setState({ addOptions: {} });
            this.setState({ compType: compType, compName: compInfo.name });
        }
    }

    constructor(props) {
        super(props);
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const compType = params.get('compType');

        const compsList =
            [
                { id: 1, name: "Office Lease" },
                { id: 2, name: "Office Sale" },
                { id: 3, name: "Industrial Lease" },
                { id: 4, name: "Industrial Sale" },
                { id: 5, name: "Retail Lease" },
                { id: 6, name: "Retail Sale" },
                { id: 7, name: "Land Sale" },
                { id: 8, name: "Multi-Family" }
            ];


        var compInfo = compsList.find(w => w.id == compType);
        if (!compInfo) {
            compInfo = { id: 0, name: "Invalid Comp Type" };
        }

        const submarket16Options = [{ label: "", value: "" },
        { label: "Clayton", value: "Clayton" },
        { label: "Westport", value: "Westport" },
        { label: "Olive/I-270", value: "Olive/I-270" },
        { label: "Chesterfield", value: "Chesterfield" },
        { label: "Manchester/I-270", value: "Manchester/I-270" },
        { label: "I-44/I-270", value: "I-44/I-270" },
        { label: "Earth City", value: "Earth City" },
        { label: "Airport", value: "Airport" },
        { label: "St. Charles County", value: "St. Charles County" },
        { label: "St. Louis City", value: "St. Louis City" },
        { label: "Metro East", value: "Metro East" },
        { label: "Other", value: "Other" }]

        const submarket34Options = [{ label: "", value: "" },
            { label: "Airport", value: "Airport" },
            { label: "Earth City", value: "Earth City" },
            { label: "Westport", value: "Westport" },
            { label: "St. Louis City", value: "St. Louis City" },
            { label: "Metro East", value: "Metro East" },
            { label: "Mid County", value: "Mid County" },
            { label: "Chesterfield", value: "Chesterfield" },
            { label: "Hanley/Brentwood", value: "Hanley/Brentwood" },
            { label: "Fenton", value: "Fenton" },
            { label: "South County", value: "South County" },
            { label: "North County", value: "North County" },
            { label: "West County", value: "West County" },
            { label: "Jefferson County", value: "Jefferson County" },
            { label: "St. Charles County", value: "St. Charles County" },
            { label: "Other", value: "Other" }]

        const submarket5Options = [{ label: "", value: "" },
            { label: "Airport", value: "Airport" },
            { label: "Chesterfield", value: "Chesterfield" },
            { label: "Clayton", value: "Clayton" },
            { label: "Earth City", value: "Earth City" },
            { label: "Fenton", value: "Fenton" },
            { label: "Franklin County", value: "Franklin County" },
            { label: "Jefferson County", value: "Jefferson County" },
            { label: "Metro East", value: "Metro East" },
            { label: "Mid County", value: "Mid County" },
            { label: "North County", value: "North County" },
            { label: "Northwest County", value: "Northwest County" },
            { label: "Outer St. Louis County", value: "Outer St. Louis County" },
            { label: "South County", value: "South County" },
            { label: "Southwest County", value: "Southwest County" },
            { label: "St. Charles County", value: "St. Charles County" },
            { label: "St. Louis City", value: "St. Louis City" },
            { label: "West County", value: "West County" },
            { label: "Warren County", value: "Warren County" },
            { label: "Other", value: "Other" }
            ]

        const submarket8Options = [{ label: "", value: "" },
            { label: "Downtown", value: "Downtown" },
            { label: "North St. Louis City", value: "North St. Louis City" },
            { label: "South St. Louis City", value: "South St. Louis City" },
            { label: "North County", value: "North County" },
            { label: "West County", value: "West County" },
            { label: "South County", value: "South County" },
            { label: "Mid County", value: "Mid County" },
            { label: "St. Charles County", value: "St. Charles County" },
            { label: "Jefferson County", value: "Jefferson County" },
            { label: "Metro East", value: "Metro East" },
            { label: "Other", value: "Other" }]

        const rateTypeOptions = [{ label: "", value: "" },
            { label: "Full Service", value: "Full Service" },
            { label: "Gross", value: "Gross" },
            { label: "Modified Gross", value: "Modified Gross" },
            { label: "NNN", value: "NNN" }]

        const leaseTypeOptions = [{ label: "", value: "" },
        { label: "New Lease", value: "New Lease" },
        { label: "Sublease", value: "Sublease" },
        { label: "Renewal", value: "Renewal" },
        { label: "Renewal/Expansion", value: "Renewal/Expansion" }]

        //buildingClass
        const buildingClassOptions = [{ label: "", value: "" },
        { label: "A", value: "A" },
        { label: "B", value: "B" },
            { label: "C", value: "C" }]

        const saleTypeOptions = [{ label: "", value: "" },
            { label: "Investment", value: "Investment" },
            { label: "User", value: "User" }]

        const qtrOptions = [{ label: "X", value: "X" },
            { label: "1", value: "1" },
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" }]

        const productTypesOptions = [{ label: "", value: "" },
        { label: "MF", value: "MF" },
        { label: "WD", value: "WD" },
            { label: "OS", value: "OS" },
            { label: "Flex", value: "Flex" }]

        const stateOptions = [{ label: "", value: "" },
        { label: "AL", value: "AL" },
        { label: "AK", value: "AK" },
        { label: "AZ", value: "AZ" },
        { label: "AR", value: "AR" },
        { label: "CA", value: "CA" },
        { label: "CO", value: "CO" },
        { label: "CT", value: "CT" },
        { label: "DE", value: "DE" },
        { label: "DC", value: "DC" },
        { label: "FL", value: "FL" },
        { label: "GA", value: "GA" },
        { label: "HI", value: "HI" },
        { label: "ID", value: "ID" },
        { label: "IL", value: "IL" },
        { label: "IN", value: "IN" },
        { label: "IA", value: "IA" },
        { label: "KS", value: "KS" },
        { label: "KY", value: "KY" },
        { label: "LA", value: "LA" },
        { label: "ME", value: "ME" },
        { label: "MD", value: "MD" },
        { label: "MA", value: "MA" },
        { label: "MI", value: "MI" },
        { label: "MN", value: "MN" },
        { label: "MS", value: "MS" },
        { label: "MO", value: "MO" },
        { label: "MT", value: "MT" },
        { label: "NE", value: "NE" },
        { label: "NV", value: "NV" },
        { label: "NH", value: "NH" },
        { label: "NJ", value: "NJ" },
        { label: "NM", value: "NM" },
        { label: "NY", value: "NY" },
        { label: "NC", value: "NC" },
        { label: "ND", value: "ND" },
        { label: "OH", value: "OH" },
        { label: "OK", value: "OK" },
        { label: "OR", value: "OR" },
        { label: "PA", value: "PA" },
        { label: "RI", value: "RI" },
        { label: "SC", value: "SC" },
        { label: "SD", value: "SD" },
        { label: "TN", value: "TN" },
        { label: "TX", value: "TX" },
        { label: "UT", value: "UT" },
        { label: "VT", value: "VT" },
        { label: "VA", value: "VA" },
        { label: "WA", value: "WA" },
        { label: "WV", value: "WV" },
        { label: "WI", value: "WI" },
        { label: "WY", value: "WY" }]
        this.state = {
            addOptions: {},
            compType: compType,
            compName: compInfo.name,
            compFieldOrder: [
                ['leaseCommencement', 'submarket16', 'tenant', 'buildingName', 'address', 'city', 'state',
                    'zip', 'leasedSF', 'term', 'effectiveRate', 'rateType', 'TISF', 'leaseExpDate', 'leaseType',  'buildingClass',
                    'tenantRepFirm', 'landlordRepFirm', 'comments', 'source', 'dateEntered'], //1
                ['dateSold', 'submarket16', 'buyer', 'seller', 'buildingName', 'address', 'city', 'state',
                    'zip', 'salePrice', 'saleType', 'occupancyPercent', 'NOI', 'capRate', 'buildingSize', 'yearBuilt',
                    'buildingClass', 'buyerRepFirm', 'sellerRepFirm', 'comments', 'source', 'pressRelease', 'dateEntered'], //2
                ['leaseCommencement', 'submarket345', 'tenant', 'buildingName', 'address', 'city', 'state', 'zip', 'commencementDate',
                    'leasedSF', 'term', 'effectiveRate', 'rateType', 'TISF', 'leaseType', 'leaseExpDate', 
                    'percentOffice', 'lotSize', 'ceilingHeight', 'productType', 'buildingClass', 'tenantRepFirm', 'landlordRepFirm',
                    'comments', 'source', 'pressRelease', 'dateEntered'], //3
                ['dateSold', 'submarket345', 'buyer', 'seller', 'buildingName', 'address', 'city', 'state',
                    'zip', 'saleType', 'occupancyPercent', 'NOI', 'capRate', 'salePrice', 'buildingSize', 'percentOffice', 'lotSize',
                    'ceilingHeight', 'productType', 'yearBuilt', 'buildingClass', 'buyerRepFirm', 'sellerRepFirm', 'comments',
                    'source', 'pressRelease', 'dateEntered'], //4
                ['leaseCommencement', 'submarket5', 'tenant', 'buildingName', 'address', 'city', 'state', 'zip', 
                    'leasedSF', 'term', 'effectiveRate', 'rateType', 'TISF', 'transactionType',  'leaseExpDate', 
                    'tenantRepFirm', 'landlordRepFirm',
                    'comments', 'source', 'pressRelease', 'dateEntered'], //5
                ['dateSold', 'submarket5', 'buyer', 'seller', 'buildingName', 'address', 'city', 'state',
                    'zip', 'salePrice', 'saleType', 'occupancyPercent', 'NOI', 'capRate', 'buildingSize', 'yearBuilt', 'buyerRepFirm',
                    'sellerRepFirm', 'comments', 'source', 'pressRelease', 'dateEntered'], //6
                ['dateSold', 'submarket16', 'buyer', 'seller', 'address', 'city', 'state',
                    'zip', 'acres', 'salePrice', 'buyerRepFirm', 'sellerRepFirm', 'comments', 'source', 'pressRelease', 'dateEntered'], //7
                ['dateSold', 'submarket8', 'buyer', 'seller', 'propertyName', 'address', 'city', 'state',
                    'zip', 'salePrice', 'units', 'capRate', 'buyerRepFirm', 'sellerRepFirm', 'comments',
                    'source', 'pressRelease', 'dateEntered'] //8
            ],
            fieldCompTypes:
                [
                    {
                        fieldName: 'leaseCommencement',
                        validComp: [1, 3, 5],
                        varName: 'leaseCommencement',
                        inputType: "yearQTR",
                        label: "Lease Commencement Date (Year/Qtr)",
                        selectList: qtrOptions
                    },
                    {
                        fieldName: 'dateSold',
                        validComp: [2, 3, 5, 7, 8],
                        varName: 'leaseCommencement',
                        inputType: "yearQTR",
                        label: "Date Sold (Year/Qtr)",
                        selectList: qtrOptions
                    },
                    {
                        fieldName: 'submarket16',
                        validComp: [1, 6],
                        varName: 'submarket',
                        inputType: "select",
                        label: "Submarket",
                        selectList: submarket16Options
                    },
                    {
                        fieldName: 'TISF',
                        validComp: [1, 6],
                        varName: 'tisf',
                        inputType: "number",
                        label: "T.I. / SF",
                        selectList: null
                    },
                    {
                        fieldName: 'submarket345',
                        validComp: [3,4,5],
                        varName: 'submarket',
                        inputType: "select",
                        label: "Submarket",
                        selectList: submarket34Options
                    },
                    {
                        fieldName: 'submarket5',
                        validComp: [3, 4, 5],
                        varName: 'submarket',
                        inputType: "select",
                        label: "Submarket",
                        selectList: submarket5Options
                    },
                    {
                        fieldName: 'submarket8',
                        validComp: [8],
                        varName: 'submarket',
                        inputType: "select",
                        label: "Submarket",
                        selectList: submarket8Options
                    },
                    {
                        fieldName: 'tenant',
                        validComp: [1, 3, 5],
                        varName: 'tenant',
                        inputType: "input",
                        label: "Tenant",
                        selectList: null
                    },
                    {
                        fieldName: 'buildingName',
                        validComp: [1, 2, 3, 4, 5, 6],
                        varName: 'buildingName',
                        inputType: "input",
                        label: "Building Name",
                        selectList: null
                    },
                    {
                        fieldName: 'propertyName',
                        validComp: [8],
                        varName: 'buildingName',
                        inputType: "input",
                        label: "Property Name",
                        selectList: null
                    },
                    {
                        fieldName: 'address',
                        validComp: [1, 2, 3, 4, 5, 6, 7, 8],
                        varName: 'address',
                        inputType: "input",
                        label: "Street Address",
                        selectList: null
                    },
                    {
                        fieldName: 'city',
                        validComp: [1, 2, 3, 4, 5, 6, 7, 8],
                        varName: 'city',
                        inputType: "input",
                        label: "City",
                        selectList: null
                    },
                    {
                        fieldName: 'state',
                        validComp: [1, 2, 3, 4, 5, 6, 7, 8],
                        varName: 'state',
                        inputType: "select",
                        label: "State",
                        selectList: stateOptions
                    },
                    {
                        fieldName: 'zip',
                        validComp: [1, 2, 3, 4, 5, 6, 7, 8],
                        varName: 'zip',
                        inputType: "input",
                        label: "Zip",
                        selectList: null
                    },
                    {
                        fieldName: 'effectiveRate',
                        validComp: [1, 3, 5],
                        varName: 'effectiveRate',
                        inputType: "number",
                        label: "Effective Rate",
                        selectList: null
                    },
                    {
                        fieldName: 'leasedSF',
                        validComp: [1, 3, 5],
                        varName: 'leasedSF',
                        inputType: "number",
                        label: "Leased SF",
                        selectList: null
                    },
                    {
                        fieldName: 'term',
                        validComp: [1, 3, 5],
                        varName: 'term',
                        inputType: "number",
                        label: "Term (months)",
                        selectList: null
                    },
                    {
                        fieldName: 'rateType',
                        validComp: [1, 3, 5],
                        varName: 'rateType',
                        inputType: "select",
                        label: "Rate Type",
                        selectList: rateTypeOptions
                    },
                    {
                        fieldName: 'leaseExpDate',
                        validComp: [1, 3, 5],
                        varName: 'leaseExpDate',
                        inputType: "date",
                        label: "Lease Exp. Date",
                        selectList: rateTypeOptions
                    },
                    {
                        fieldName: 'leaseType',
                        validComp: [1, 3, 5],
                        varName: 'leaseType',
                        inputType: "select",
                        label: "Lease Type",
                        selectList: leaseTypeOptions
                    },
                    {
                        fieldName: 'transactionType',
                        validComp: [1, 3, 5],
                        varName: 'leaseType',
                        inputType: "select",
                        label: "Transaction Type",
                        selectList: leaseTypeOptions
                    },
                    {
                        fieldName: 'buildingOwner',
                        validComp: [1, 3, 5],
                        varName: 'buildingOwner',
                        inputType: "input",
                        label: "Building Owner",
                        selectList: null
                    },
                    {
                        fieldName: 'buildingSize',
                        validComp: [1, 2, 3, 5, 6, 8],
                        varName: 'buildingSize',
                        inputType: "number",
                        label: "Building Size",
                        selectList: null
                    },
                    {
                        fieldName: 'perSQFT',
                        validComp: [1, 2, 3, 5, 6, 8],
                        varName: 'perSQFT',
                        inputType: "fromTo",
                        label: "Per SQFT",
                        selectList: null
                    },
                    {
                        fieldName: 'yearBuilt',
                        validComp: [1, 2, 3, 4, 5, 6, 8],
                        varName: 'yearBuilt',
                        inputType: "input",
                        label: "Year Built",
                        selectList: null
                    },
                    {
                        fieldName: 'buildingClass',
                        validComp: [1, 2, 3, 4],
                        varName: 'buildingClass',
                        inputType: "select",
                        label: "Building Class",
                        selectList: buildingClassOptions
                    },
                    {
                        fieldName: 'tenantRepFirm',
                        validComp: [1, 3, 5],
                        varName: 'tenantRepFirm',
                        inputType: "input",
                        label: "Tenant Rep Firm",
                        selectList: null
                    },
                    {
                        fieldName: 'landlordRepFirm',
                        validComp: [1, 3, 5],
                        varName: 'landlordRepFirm',
                        inputType: "input",
                        label: "Landlord Rep Firm",
                        selectList: null
                    },
                    {
                        fieldName: 'buyer',
                        validComp: [2, 4, 6, 7, 8],
                        varName: 'buyer',
                        inputType: "input",
                        label: "Buyer",
                        selectList: null
                    },
                    {
                        fieldName: 'seller',
                        validComp: [2, 4, 6],
                        varName: 'seller',
                        inputType: "input",
                        label: "Seller",
                        selectList: null
                    },
                    {
                        fieldName: 'salePrice',
                        validComp: [2, 4, 6],
                        varName: 'salePrice',
                        inputType: "number",
                        label: "Sale Price",
                        selectList: null
                    },
                    {
                        fieldName: 'acerage',
                        validComp: [2, 4, 6],
                        varName: 'acerage',
                        inputType: "number",
                        label: "Acres",
                        selectList: null
                    },
                    {
                        fieldName: 'saleType',
                        validComp: [2, 4, 6],
                        varName: 'saleType',
                        inputType: "select",
                        label: "Sale Type",
                        selectList: saleTypeOptions
                    },
                    {
                        fieldName: 'buyerRepFirm',
                        validComp: [2, 4, 6, 7, 8],
                        varName: 'buyerRepFirm',
                        inputType: "input",
                        label: "Buyer Rep Firm",
                        selectList: null
                    },
                    {
                        fieldName: 'sellerRepFirm',
                        validComp: [2, 4, 6, 7, 8],
                        varName: 'sellerRepFirm',
                        inputType: "input",
                        label: "Seller Rep Firm",
                        selectList: null
                    },
                    {
                        fieldName: 'acres',
                        validComp: [7],
                        varName: 'acres',
                        inputType: "number",
                        label: "Acreage",
                        selectList: null
                    },
                    {
                        fieldName: 'propertyName',
                        validComp: [8],
                        varName: 'propertyName',
                        inputType: "input",
                        label: "Property Name",
                        selectList: null
                    },
                    {
                        fieldName: 'units',
                        validComp: [8],
                        varName: 'units',
                        inputType: "number",
                        label: "Units",
                        selectList: null
                    },
                    {
                        fieldName: 'comments',
                        validComp: [1, 3, 5],
                        varName: 'comments',
                        inputType: "textArea",
                        label: "Comments",
                        selectList: null
                    },
                    {
                        fieldName: 'source',
                        validComp: [1, 3, 5],
                        varName: 'source',
                        inputType: "input",
                        label: "Source",
                        selectList: null
                    },
                    {
                        fieldName: 'NOI',
                        validComp: [1, 3, 5],
                        varName: 'noi',
                        inputType: "input",
                        label: "NOI",
                        selectList: null
                    },
                    {
                        fieldName: 'occupancyPercent',
                        validComp: [1, 3, 5],
                        varName: 'occupancyPercent',
                        inputType: "input",
                        label: "Occupancy %",
                        selectList: null
                    },
                    {
                        fieldName: 'capRate',
                        validComp: [1, 3, 5],
                        varName: 'capRate',
                        inputType: "input",
                        label: "Cap Rate",
                        selectList: null
                    },
                    {
                        fieldName: 'pressRelease',
                        validComp: [1, 3, 5],
                        varName: 'pressRelease',
                        inputType: "textArea",
                        label: "Press Release",
                        selectList: null
                    },
                    {
                        fieldName: 'dateEntered',
                        validComp: [1, 3, 5],
                        varName: 'dateEntered',
                        inputType: "date",
                        label: "Date Entered",
                        selectList: null
                    },
                    {
                        fieldName: 'commencementDate',
                        validComp: [1, 3, 5],
                        varName: 'commencementDate',
                        inputType: "date",
                        label: "Commencement Date",
                        selectList: null
                    },
                    {
                        fieldName: 'percentOffice',
                        validComp: [1, 3, 5],
                        varName: 'percentOffice',
                        inputType: "input",
                        label: "Percent Office",
                        selectList: null
                    },
                    {
                        fieldName: 'lotSize',
                        validComp: [1, 3, 5],
                        varName: 'lotSize',
                        inputType: "number",
                        label: "Lot Size",
                        selectList: null
                    },
                    {
                        fieldName: 'ceilingHeight',
                        validComp: [1, 3, 5],
                        varName: 'ceilingHeight',
                        inputType: "input",
                        label: "Ceiling Height",
                        selectList: null
                    },
                    {
                        fieldName: 'productType',
                        validComp: [1, 3, 5],
                        varName: 'productType',
                        inputType: "select",
                        label: "Product Type",
                        selectList: productTypesOptions
                    }
                ],
            sortedComps: []
        }
        this.checkAuthenticated();
    }

    updateaddOptionsValueByKey = (value, key) => {
        var tempaddOptions = this.state.addOptions;
        tempaddOptions[key] = value;
        this.setState({ addOptions: tempaddOptions })
    }

    
    renderFields() {
        let sortList = this.state.compFieldOrder[this.state.compType - 1];
        return sortList.map((fieldName) => {
            let field = this.state.fieldCompTypes.find((field) => field.fieldName == fieldName);

            return (
                <>
                    {field.inputType === "yearQTR" && (
                        <>
                            <Row className="rowSpacing"  >
                                <Col style={{ textAlign: 'right' }} >
                                    <div id="plain">&nbsp;
                                        <label className="leftLabel alignLeftText">{field.label}</label>
                                    </div>
                                </Col>
                                <Col>
                                    <div id="plain">&nbsp;
                                        <label className="fromToLabel">Year:</label>
                                        <input type="text"
                                            name={`${field.varName}Year`}
                                            value={this.state.addOptions[`${field.varName}Year`] || ''}
                                            onChange={(e) => {
                                                this.updateaddOptionsValueByKey(e.target.value, `${field.varName}Year`);
                                            }}
                                        />
                                    </div>
                                    <div id="plain">&nbsp;
                                        <label className="fromToLabel">QTR:</label>
                                        <select
                                            options={this.state[field.selectList]}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            components={{
                                                Option
                                            }}
                                            name={`${field.varName}QTR`}
                                            onChange={(e) => {
                                                this.updateaddOptionsValueByKey(e.target.value, `${field.varName}QTR`);
                                            }}
                                            value={this.state.addOptions[`${field.varName}QTR`] || ''}
                                        >
                                            {field.selectList.map(option => {
                                                return (
                                                    <option key={option.value}>
                                                        {option.label}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                </Col>
                            </Row>
                        </>
                    )}

                    {field.inputType === "input" && (
                        <>
                            <Row className="rowSpacing"  >
                                <Col style={{ textAlign: 'right' }} >
                                    <div id="plain">&nbsp;
                                        <label className="leftLabel alignLeftText">{field.label}</label>
                                    </div>
                                </Col>
                                <Col>
                                    <div id="plain">&nbsp;
                                        <input type="text"
                                            name={field.varName}
                                            value={this.state.addOptions[field.varName] || ''}
                                            onChange={(e) => {
                                                this.updateaddOptionsValueByKey(e.target.value, field.varName);
                                            }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </>
                    )}

                    {field.inputType === "number" && (
                        <>
                            <Row className="rowSpacing"  >
                                <Col style={{ textAlign: 'right' }} >
                                    <div id="plain">&nbsp;
                                        <label className="leftLabel alignLeftText">{field.label}</label>
                                    </div>
                                </Col>
                                <Col>
                                    <div id="plain">&nbsp;
                                        <input type="number"
                                            name={field.varName}
                                            value={this.state.addOptions[field.varName] || ''}
                                            onChange={(e) => {
                                                this.updateaddOptionsValueByKey(e.target.value, field.varName);
                                            }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </>
                    )}


                    {field.inputType === "select" && (
                        <>
                            <Row className="rowSpacing">
                                <Col style={{ textAlign: 'right' }} >
                                    <div id="plain">&nbsp;
                                        <label className="leftLabel alignLeftText">{field.label}</label>
                                    </div>
                                </Col>
                                <Col>
                                    <div id="plain">&nbsp;
                                        <select
                                            options={this.state[field.selectList]}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            components={{
                                                Option
                                            }}
                                            onChange={(e) => {
                                                this.updateaddOptionsValueByKey(e.target.value, field.varName);
                                            }}
                                            value={this.state.addOptions[field.varName] || ''}
                                        >
                                            {field.selectList.map(option => {
                                                return (
                                                    <option key={option.value}>
                                                        {option.label}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                </Col>
                            </Row>
                        </>
                    )}

                    {field.inputType === "date" && (
                        <>
                            <Row className="rowSpacing"  >
                                <Col style={{ textAlign: 'right' }} >
                                    <div id="plain">&nbsp;
                                        <label className="leftLabel alignLeftText">{field.label}</label>
                                    </div>
                                </Col>
                                <Col>
                                    <div id="plain">&nbsp;
                                        <input
                                            type="date"
                                            value={moment(this.state.addOptions[field.varName], "YYYY-MM-DDTHH:mm:ss").format("yyyy-MM-DD") || ''}
                                            onChange={(e) => {
                                                this.updateaddOptionsValueByKey(e.target.value, field.varName);
                                            }}
                                            name={field.varName}
                                            id={field.varName}
                                            className="inputSpacing"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </>
                    )}
                    {field.inputType === "textArea" && (
                        <>
                            <Row className="rowSpacing"  >
                                <Col style={{ textAlign: 'right' }} >
                                    <div id="plain">&nbsp;
                                        <label className="leftLabel alignLeftText">{field.label}</label>
                                    </div>
                                </Col>
                                <Col>
                                    <div id="plain">&nbsp;
                                        <textarea
                                            type="textarea"
                                            value={this.state.addOptions[field.varName] || ''}
                                            onChange={(e) => {
                                                this.updateaddOptionsValueByKey(e.target.value, field.varName);
                                            }}
                                            name={field.varName}
                                            id={field.varName}
                                            className="inputSpacing textAreaHeight"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </>
                    )}
                </>

            );
        });
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var isAdmin = false;
        var isComps = false;
        if (isAuthenticated) {
            isAdmin = await AdminFunctions.isAdminAsync();
            isComps = await AdminFunctions.isRole("Comps");
            if (!isComps) {
                this.props.history.push('/login');
            }
        }
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async componentDidMount() {
        var _token = Session.getToken();
    }

    async Add() {
        const token = Session.getToken();
        this.state.addOptions.compType = this.state.compType;
        const response = await fetch('api/Comps/EditComps', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state.addOptions)
        });
        const data = await response.json();
        this.setState({ addOptions: data, loading: false, noResults: data.length === 0 ? true : false });
        //How to get - localStorage.getItem();
        if (this.state.addOptions.id) {
            window.location.href = '/Comps/CompSummary?compId=' + this.state.addOptions.id + '&compType=' + this.state.compType;
        }
        //window.open('/Lease/ActiveLeases?search=1', '_self');
    }

    render() {
        return (
            <div className="pageDiv">
                <div id="head">
                    <h3 style={{ textAlign: 'center' }}>Add Comp: {this.state.compName}</h3>
                </div>
                <div id="body" className="g-light-gray-c">
                    {this.renderFields()}
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            &nbsp;
                        </Col>
                        <Col>
                            <div id="controls" style={{ textAlign: 'left' }}>
                                <button className="gButton" style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px" }} onClick={() => {
                                    this.Add();
                                }} >Add</button>
                            </div>
                        </Col>
                    </Row>
                </div>

            </div>
        );
    }


}

